<template>
  <div class="header-ordos-wrap">
    <div
      class="header-ordos"
      :class="{ 'header-ordos--fixed': isSolidHeader }"
    >
      <div class="header-ordos__inner">
        <img
          class="header-ordos__logo"
          src="@/assets/ordos/logo.png"
          alt="鄂尔多斯暖城工匠线上学习平台"
        />

        <div
          v-if="userInfo && userInfo != ''"
          class="user-state"
          @mouseenter="userOpeShow = true"
          @mouseleave="userOpeShow = false"
        >
          <img
            v-if="userInfo.avatar"
            :src="userInfo.avatar"
            class="user-head-portrait"
          />

          <img
            v-else
            :src="require('@/assets/head-default-personal.png')"
            class="user-head-portrait"
          />

          <span class="user-name">{{ userInfo.nickname || userInfo.phone }}</span>

          <ul class="user-list" v-show="userOpeShow">
            <li class="option">
              <router-link to="/userCenter/material">个人中心</router-link>
            </li>
            <li class="option">
              <router-link to="/userCenter/learning">学习记录</router-link>
            </li>
            <li class="option exit" @click="exitBtn">退出</li>
          </ul>
        </div>

        <div class="user-state" v-else>
          <!-- <router-link class="auth-link" to="/welcomeRegistered">注册</router-link>
          <span class="auth-divider">/</span> -->
          <span class="auth-link login-link" @click="headerLoginBtn">登录</span>
        </div>
      </div>
    </div>

    <Login v-if="loginModal.show" />
  </div>
</template>

<script>
import Login from "@/components/pc/login.vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "HeaderOrdos",
  props: ["siteInfo", "logo"],
  components: {
    Login,
  },
  data() {
    return {
      userOpeShow: false,
      isSolidHeader: false,
    };
  },
  computed: {
    ...mapState(["loginModal", "userInfo"]),
  },
  mounted() {
    this.GetUserInfo();

    this.handleHeaderScroll();
    window.addEventListener("scroll", this.handleHeaderScroll, { passive: true });
    window.addEventListener("resize", this.handleHeaderScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleHeaderScroll);
    window.removeEventListener("resize", this.handleHeaderScroll);
  },
  methods: {
    ...mapMutations([
      "ShowLoginModal",
      "GetUserInfo",
      "ClearUserInfo",
    ]),

    handleHeaderScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      // 首屏视频是 100vh，滚到内容区时 header 变成实体固定顶部
      const headerHeight = 72;
      const threshold = window.innerHeight - headerHeight;

      this.isSolidHeader = scrollTop >= threshold;
    },

    headerLoginBtn() {
      this.ShowLoginModal();
    },

    exitBtn() {
      localStorage.removeItem("user");
      localStorage.removeItem("auth");
      localStorage.removeItem("userInfo");

      this.ClearUserInfo();

      if (this.$route.path.includes("userCenter")) {
        this.$router.push("/index");
      } else {
        this.$router.go(0);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header-ordos-wrap {
  position: relative;
  z-index: 1000;
}

.header-ordos {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 72px;
  background: rgba(0, 0, 0, 0.68);
  pointer-events: none;
  transition:
    background 0.25s ease,
    box-shadow 0.25s ease,
    position 0.25s ease;

  &__inner {
    // width: 1500px;
    max-width: calc(100% - 80px);
    height: 72px;
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    pointer-events: auto;
  }

  &__logo {
    height: 40px;
    width: auto;
    display: block;
  }
}

/* 滚动到内容区以后：实体固定头部 */
.header-ordos--fixed {
  position: fixed;
  background: rgba(0, 0, 0, 0.694);
  box-shadow: 0 4px 18px rgba(89, 0, 12, 0.18);
  backdrop-filter: blur(6px);
}

.user-state {
  display: flex;
  align-items: center;
  position: relative;
  height: 72px;
  font-size: 16px;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
  flex-shrink: 0;
}

.auth-link {
  color: #fff;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}

.auth-divider {
  margin: 0 4px;
  color: #fff;
}

.login-link {
  cursor: pointer;
}

.user-head-portrait {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

.user-name {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-list {
  position: absolute;
  top: 100%;
  right: 0;
  min-width: 120px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
  padding: 6px 0;
  text-shadow: none;
  z-index: 1001;
  pointer-events: auto;

  /* 填补与头部之间的空隙，避免移入菜单时触发 mouseleave */
  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: -8px;
    height: 8px;
  }

  .option {
    line-height: 36px;
    text-align: center;
    font-size: 14px;
    color: #333;
    cursor: pointer;

    a {
      color: #333;
      text-decoration: none;
    }

    &:hover {
      background: #f7f7f7;
    }

    &.exit {
      border-top: 1px solid #eee;
      color: #666;
    }
  }
}
</style>